module.exports = __webpack_public_path__ + "Onboardingdesign4.svg?1a13ca4f4032f752f888b04ca0f1098b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Onboardingdesign4.svg
// module id = 83
// module chunks = 0